var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBalance = function SvgBalance(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 27.733a12.4 12.4 0 1 0 0-24.8 12.4 12.4 0 0 0 0 24.8Zm0 1.6c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14-6.268 14-14 14Z",
    fill: "#5981E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.667h2.667V16H6v-1.333Zm16 0h2.667V16H22v-1.333Zm-4.668 3.45c0-.48-.153-.876-.457-1.189-.306-.313-.814-.595-1.524-.847-.711-.25-1.264-.483-1.659-.697-1.315-.707-1.972-1.75-1.972-3.132 0-.937.285-1.707.855-2.31.57-.605 1.344-.962 2.32-1.075V7.02h1.353v1.863c.983.14 1.741.556 2.277 1.248.536.69.804 1.59.804 2.696H17.28c0-.712-.16-1.272-.479-1.68-.32-.41-.752-.613-1.298-.613-.543 0-.966.146-1.271.44-.304.293-.456.713-.456 1.26 0 .49.15.885.453 1.181.302.296.814.576 1.535.841.723.267 1.29.511 1.701.738.414.225.76.482 1.042.773.282.29.5.627.652 1.004.152.378.228.82.228 1.328 0 .953-.292 1.727-.876 2.32-.584.592-1.398.941-2.442 1.05v1.649h-1.346v-1.642c-1.116-.123-1.976-.525-2.576-1.2-.6-.678-.902-1.576-.902-2.693h2.056c0 .71.18 1.262.538 1.65.358.39.865.585 1.52.585.642 0 1.133-.156 1.468-.467.336-.31.504-.721.504-1.235h.001Z",
    fill: "#5981E3"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBalance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ea1dd23db63c594f7919db663718f3da.svg";